<template>
    <div id="main-container" class="px-0">
        <div class="scrollable-container" style="overflow-y: scroll;">
            <div class="card card-container">
                <img id="img-card" class="img-card" src="@/assets/images/logo-register.png" />
                <h3 class="text-main font-weight-bold mt-3">{{ $t('Register') }}</h3>
                <Form @submit="handleRegister" :validation-schema="schema" autocomplete="off">
                    <div class="form-group">
                        <label for="name">{{ $t('Name') }}</label>
                        <Field name="name" type="text" class="form-control" />
                        <ErrorMessage name="name" class="error-feedback" />
                    </div>
                    <div class="form-group">
                        <label for="phone">{{ $t('Phone Number') }}</label>
                        <div class="input-group">
                            <div class="input-group-prepend d-flex pr-3 pl-2" style="background-color: #f8f9fa;">
                                <label class="mb-0" style="margin-top: 7px;">+62</label>
                            </div>
                            <Field name="phone" type="number" class="form-control" />
                        </div>
                        <ErrorMessage name="phone" class="error-feedback" />
                    </div>
                    <div class="form-group">
                        <label for="email">{{ $t('Email Address') }}</label>
                        <Field name="email" type="email" class="form-control" />
                        <ErrorMessage name="email" class="error-feedback" />
                    </div>
                    <div class="form-group">
                        <label for="password">{{ $t('Password') }}</label>
                        <div class="input-group">
                            <Field name="password" type="password" class="form-control" />
                            <div class="input-group-prepend d-flex align-items-center pl-3">
                                <font-awesome-icon :icon="iconToggle" @click.prevent="togglePassword"
                                    style="cursor: pointer;" />
                            </div>
                        </div>
                        <ErrorMessage name="password" class="error-feedback" />
                    </div>
                    <div class="form-group pt-3">
                        <button class="btn btn-main btn-block" :disabled="loading">
                            <span>{{ $t('Register') }}</span>
                        </button>
                    </div>
                    <div class="form-group pt-2">
                        <div class="d-flex justify-content-center">
                            <span class="text-center">
                                {{ $t('Already have an account?') }}
                                <router-link to="/login" class="text-main">{{ $t('Login') }}</router-link>
                            </span>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";

export default {
    name: "RegisterPage",
    components: {
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            name: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Name") })),
            phone: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Phone Number") }))
                .matches(/^[0-9]+$/, this.$t("Data is invalid!", { data: this.$t("Phone Number") })),
            email: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Email Address") }))
                .email(this.$t("Data is invalid!", { data: this.$t("Email Address") })),
            password: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Password") }))
                .min(6, this.$t("Password must be at least 6 characters!")),
        });

        return {
            loading: false,
            schema,
            iconToggle: "eye",
        };
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
    },
    mounted() {
        if (this.loggedIn) {
            this.$router.push("/profile");
        }
    },
    methods: {
        togglePassword() {
            //element by name password
            var password = this.$el.querySelector("input[name='password']");
            if (password.type === "password") {
                password.focus();
                password.type = "text";
                this.iconToggle = "eye-slash";
            } else {
                password.focus();
                password.type = "password";
                this.iconToggle = "eye";
            }
        },
        handleRegister(user) {
            let loader = this.$loading.show();

            this.$store.dispatch("auth/register", user).then(
                () => {
                    this.$router.push({
                        name: "Verify Email",
                        query: { userEmail: user.email, isWait: true }
                    });
                    loader.hide();
                },
                (error) => {
                    this.$vueAlert.alert((error.response && error.response.data && error.response.data.message) || error.message || error.toString(), null, 'error');
                    loader.hide();
                }
            );
        },
    },
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.card-container.card {
    max-width: 375px !important;
    padding: 40px 40px;
}

.card {
    background-color: #fff;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;

    @media screen and (max-width: 600px) {
        margin-top: 25px;
    }

    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
